import {
  ADD_SAMVERKANSPART_USERS,
  CHANGE_REQUIRED_FIELDS,
  SET_ARRANGEMANG_OVERVIEW,
  ADD_ARR_ARTISTER,
  CLEAR_ARR_ARTISTER,
  ADD_NOTISER,
  SET_ACTIVE_STEP,
  SET_CURRENTWIZARD_STEP,
} from "../constants/constants";

const initialState = {
  shouldAddUsersFromSamverkanspart: false,
  arrangemangOverview: {},
  deltagare: {
    artister: [],
    artistgrupper: [],
    grupper: [],
  },
  obligatoriskaFalt: {
    notering: null,
    sal: null,
    material: null,
    studieplan: null,
    startdatum: null,
    starttid: null,
    sluttid: null,
    planeratAntalSammankomster: null,
    planeratAntalTimmar: null,
    kulturform: null,
    huvudledare: null,
  },
  notiser: [],
  activeStep: 0,
  currentWizardStep: null,
};

export const ovrigt = (state = initialState, action) => {
  switch (action.type) {
    case ADD_SAMVERKANSPART_USERS: {
      return { ...state, shouldAddUsersFromSamverkanspart: action.payload };
    }
    case CHANGE_REQUIRED_FIELDS: {
      return { ...state, obligatoriskaFalt: action.payload };
    }
    case SET_ARRANGEMANG_OVERVIEW: {
      return { ...state, arrangemangOverview: action.payload };
    }
    case ADD_ARR_ARTISTER: {
      return {
        ...state,
        deltagare: { artister: action.payload },
      };
    }
    case CLEAR_ARR_ARTISTER: {
      return {
        ...state,
        deltagare: { artister: [] },
      };
    }
    case ADD_NOTISER: {
      return { ...state, notiser: action.payload };
    }
    case SET_ACTIVE_STEP: {
      return { ...state, activeStep: action.payload };
    }
    case SET_CURRENTWIZARD_STEP: {
      return { ...state, currentWizardStep: action.payload };
    }
    default:
      return state;
  }
};
